import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=4be3afdd&"
import script from "./PhoneIcon.vue?vue&type=script&lang=ts&"
export * from "./PhoneIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports